import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";

const PLACEHOLDER = "Disponible prochainement";

function Doc({ children }) {
  return (
    <section className="relative z-10 mx-auto max-w-3xl px-5 py-16 lg:px-8">
      <Reveal>
        <div className="space-y-6 text-slate-300 [&_h2]:mt-8 [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:text-white [&_p]:mt-2 [&_p]:leading-relaxed [&_li]:mt-1">
          {children}
        </div>
      </Reveal>
    </section>
  );
}

export function MentionsLegales() {
  return (
    <div data-testid="mentions-page">
      <Seo title="Mentions légales" path="/mentions-legales" description="Mentions légales du site Speed Détresse." />
      <PageHero overline="Informations légales" title={["Mentions", "légales"]} testid="mentions-hero" />
      <Doc>
        <h2>Éditeur du site</h2>
        <p>Speed Détresse — {PLACEHOLDER} (raison sociale, forme juridique, capital, SIREN/SIRET, RCS).</p>
        <p>Siège social : {PLACEHOLDER}. Secteur d'intervention : Amiens et environs.</p>
        <p>Contact : speeddetresse@gmail.com — Téléphone : 07 68 57 02 27.</p>
        <h2>Directeur de la publication</h2>
        <p>{PLACEHOLDER}.</p>
        <h2>Hébergement</h2>
        <p>{PLACEHOLDER} (nom et coordonnées de l'hébergeur).</p>
        <h2>Propriété intellectuelle</h2>
        <p>L'ensemble des contenus du site (textes, visuels, marques) est protégé. Toute reproduction sans autorisation est interdite.</p>
        <h2>Responsabilité</h2>
        <p>Les informations affichées sont fournies à titre indicatif. Les tarifs, prestations et zones d'intervention sont confirmés lors d'un rendez-vous et dans l'application Speed Détresse.</p>
      </Doc>
    </div>
  );
}

export function Confidentialite() {
  return (
    <div data-testid="confidentialite-page">
      <Seo title="Politique de confidentialité" path="/confidentialite" description="Politique de confidentialité et protection des données personnelles de Speed Détresse." />
      <PageHero overline="Protection des données" title={["Politique de", "confidentialité"]} testid="confidentialite-hero" />
      <Doc>
        <h2>Responsable du traitement</h2>
        <p>Speed Détresse — {PLACEHOLDER}.</p>
        <h2>Données collectées</h2>
        <p>Via nos formulaires : identité, coordonnées, informations sur vos logements, message, et pièces jointes (CV, documents). Ces données servent uniquement à traiter votre demande.</p>
        <h2>Finalités</h2>
        <p>Gestion des demandes d'abonnement, de rendez-vous, de prestations, de candidatures et de contact ; création du dossier correspondant dans l'application Speed Détresse.</p>
        <h2>Base légale & durée de conservation</h2>
        <p>Consentement et intérêt légitime. Durée de conservation : {PLACEHOLDER}, selon les règles validées par Speed Détresse.</p>
        <h2>Vos droits (RGPD)</h2>
        <p>Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition. Pour l'exercer : speeddetresse@gmail.com.</p>
        <h2>Sécurité</h2>
        <p>Les échanges sont chiffrés, les accès contrôlés côté serveur et les pièces jointes stockées de manière sécurisée.</p>
      </Doc>
    </div>
  );
}

export function Cookies() {
  return (
    <div data-testid="cookies-page">
      <Seo title="Gestion des cookies" path="/cookies" description="Informations sur l'utilisation des cookies sur le site Speed Détresse." />
      <PageHero overline="Vie privée" title={["Gestion des", "cookies"]} testid="cookies-hero" />
      <Doc>
        <h2>Qu'est-ce qu'un cookie ?</h2>
        <p>Un cookie est un petit fichier déposé sur votre appareil lors de la visite du site.</p>
        <h2>Cookies utilisés</h2>
        <p>Cookies strictement nécessaires au fonctionnement du site (toujours actifs) et, avec votre consentement, cookies de mesure d'audience.</p>
        <h2>Votre choix</h2>
        <p>Vous acceptez ou refusez les cookies non essentiels via le bandeau affiché lors de votre première visite. Vous pouvez modifier votre choix en effaçant les données du site dans votre navigateur.</p>
      </Doc>
    </div>
  );
}
